import { Observable } from 'rxjs';

import { WorkPackagePriorityDto } from '@api/backend-connector/models';
import {
  SmartPickerHandler,
  SmartPickerPage,
  defaultSmartPickerOptions,
} from 'src/app/components-form/smart-input-entity/smart-picker.handler';
import { WorkPackagePrioritiesService } from 'src/app/services/work-package-priority.service';

type WorkPackagePriorityPickerContext = void;

export class WorkPackagePriorityPickerHandler extends SmartPickerHandler<WorkPackagePriorityDto> {
  constructor(
    private workPackagePriorityService: WorkPackagePrioritiesService,
    private context: WorkPackagePriorityPickerContext,
  ) {
    super({
      ...defaultSmartPickerOptions,
      virtualScroll: false,
      filter: {
        enabled: false,
      },
      initialFetchedItems: 20,
      preloadStrategy: { enabled: true, autoSelectSingleChoice: true },
    });
  }

  override getItems(params: {
    offset?: number | undefined;
    limit?: number | undefined;
    query?: string;
    excludeIds: string[] | undefined;
  }): Observable<SmartPickerPage<WorkPackagePriorityDto>> {
    return this.workPackagePriorityService.listWorkPackagePriorities({
      offset: params.offset,
      limit: params.limit,
      query: params.query,
      sorting: ['-position'],
      // excludeIds: params.excludeIds,
    });
  }
}
